import axios from "axios";
import { API } from "../utils/apiEndpoints";
import Authorization from "../utils/authorization";
import { buildSearchParams } from "../utils/searchFilters";

axios.defaults.baseURL = (process.env.REACT_APP_BASE_URL || "").replace(
  /\/+$/,
  "",
);

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    console.log(error);
    if (error.response && error.response.status === 401) {
      // window.localStorage.removeItem("pfToken");
      Authorization.logout();
    }
    return Promise.reject(error);
  },
);

const apiService = ({
  url = "",
  method = "GET",
  body = null,
  authToken = Authorization.getAccessToken(),
  headers = {},
}) => {
  const dataOrParams = ["GET", "DELETE"].includes(method) ? "params" : "data";
  if (!headers["Content-Type"]) {
    headers["Content-Type"] = "application/json";
  }
  if (authToken) {
    headers["Authorization"] = `Bearer ${authToken}`;
  } else delete headers.Authorization;
  // Only attach a payload when there is one. Axios serializes `data: null`
  // into the literal string "null", which the backend's strict JSON body
  // parser rejects with a 400 on bodyless POST/PATCH calls.
  const payload =
    body === null || body === undefined ? {} : { [dataOrParams]: body };
  return axios.request({
    url,
    method,
    headers,
    ...payload,
  });
};

export const getProfileData = () => {
  return apiService({
    url: "/v1/profiles",
    method: "GET",
  });
};
export const getCustomerProfileData = (id) => {
  return apiService({
    url: `${process.env.REACT_APP_BASE_URL}/cp/v1/profiles/${id}`,
    method: "GET",
  });
};

export const updateProfileData = (payload) => {
  return apiService({
    url: "/v1/profiles",
    method: "PATCH",
    body: payload,
  });
};
export const updateCustomerProfileData = (payload, id) => {
  return apiService({
    url: `${process.env.REACT_APP_BASE_URL}/cp/v1/profiles/${id}`,
    method: "PATCH",
    body: payload,
  });
};

export const getAssosiateProfileData = () => {
  let assosiateProfileId = Authorization.getProfileId();

  return apiService({
    url: `${API.associateProfile}${assosiateProfileId ?? 1}`,
    method: "GET",
  });
};

export const updateAssosiateProfileData = (payload) => {
  let assosiateProfileId = Authorization.getProfileId();

  return apiService({
    url: `${API.associateProfile}${assosiateProfileId}`,
    method: "PATCH",
    body: payload,
  });
};

export const getSubordinateProfileData = () => {
  let ProfileId = Authorization.getProfileId();

  return apiService({
    url: `${API.subOrdinateUpdateProfile}${ProfileId}`,
    method: "GET",
  });
};

export const updateSubordinateProfileData = (payload) => {
  let ProfileId = Authorization.getProfileId();

  return apiService({
    url: `${API.subOrdinateUpdateProfile}${ProfileId}`,
    method: "PATCH",
    body: payload,
  });
};

export const getPreferenceData = () => {
  return apiService({
    url: "/v1/profile/preferences",
    method: "GET",
  });
};

export const updatePreferenceData = (payload) => {
  return apiService({
    url: "/v1/profile/preferences",
    method: "PATCH",
    body: payload,
  });
};

export const uploadImages = (payload) => {
  return apiService({
    headers: { ["Content-Type"]: "multipart/form-data" },
    url: "/v1/profiles/images/uploads",
    method: "POST",
    body: payload,
  });
};

export const deleteProfileImage = (imageId) => {
  return apiService({
    url: "/v1/profiles/images/deletes",
    method: "DELETE",
    body: { image_id: imageId },
  });
};

export const getDropwdownValues = () => {
  return apiService({
    url: "/v1/reference/drop-down",
    method: "GET",
  });
};

export const getStates = () => {
  return apiService({
    url: "/v1/reference/states",
    method: "GET",
  });
};

export const verifyPhone = (payload) => {
  return apiService({
    url: "/v1/customer/otp/verify",
    method: "PATCH",
    body: payload,
  });
};

export const generateOtp = (payload) => {
  return apiService({
    url: "/v1/customer/otp/generate",
    method: "PATCH",
    body: payload,
  });
};

//Home section

export const getDailyRecommendation = (page = 1, limit = 10) => {
  return apiService({
    url: "/v1/matches/daily",
    method: "GET",
    body: {page, limit},
  });
};

export const getNewProfileMatches = (page = 1, limit = 10) => {
  return apiService({
    url: "/v1/matches/new-profiles",
    method: "GET",
    body: {page, limit},
  });
};

export const getNewSubscribers = () => {
  return apiService({
    url: "/v1/profiles/newly-subscribed",
    method: "GET",
  });
};

export const getNewJoiners = () => {
  return apiService({
    url: "/v1/profiles/newly-joined",
    method: "GET",
  });
};

export const getHoroscopeMatches = (page = 1, limit = 10) => {
  return apiService({
    url: "/v1/matches/horoscopic",
    method: "GET",
    body: {page, limit},
  });
};

export const getPreferenceMatches = () => {
  return apiService({
    url: "/v1/matches/preference",
    method: "GET",
  });
};

export const getProfileAssist = () => {
  return apiService({
    url: "/v1/profiles/assist",
    method: "GET",
  });
};

// Marriage profile
export const getProfileDetails = (id) => {
  return apiService({
    url: `/v1/profiles/details/${id}`,
    method: "GET",
  });
};

export const getMobileNumber = (id) => {
  return apiService({
    url: `/v1/profiles/details/${id}/contact`,
    method: "POST",
    body: {},
  });
};

// Wishlist
export const getWishList = () => {
  return apiService({
    url: "/v1/users/shortlist",
    method: "GET",
  });
};

export const sendWishList = (payload) => {
  return apiService({
    url: "/v1/users/shortlist",
    method: "PATCH",
    body: payload,
  });
};

// Wishlist
export const getViewedProfile = () => {
  return apiService({
    url: "/v1/users/profile-views",
    method: "GET",
  });
};

export const updateViewedProfile = (payload) => {
  return apiService({
    url: "/v1/users/profile-views",
    method: "POST",
    body: payload,
  });
};

// Wishlist
export const getEarningsInfo = (type) => {
  return apiService({
    url: `${API.getEarnings}${type}`,
    method: "GET",
  });
};

// Unified payments
export const initiatePayment = (payload) => {
  return apiService({
    url: "/v1/payment/initiate",
    method: "POST",
    body: payload,
  });
};

export const completePayment = (payload) => {
  return apiService({
    url: "/v1/payment/complete",
    method: "POST",
    body: payload,
  });
};

// Legacy Razorpay payment flow
export const fetchRazorPay = (payload) => {
  return apiService({
    url: "/v1/razor/payment",
    method: "POST",
    body: payload,
  });
};

export const completeRazorPay = (payload) => {
  return apiService({
    url: "/v1/razor/payment/complete",
    method: "POST",
    body: payload,
  });
};

// Payment history
export const getPaymentHistory = () => {
  return apiService({
    url: "/v1/payment/history",
    method: "GET",
  });
};

export const getMyMembership = () => {
  return apiService({
    url: "/v1/my/membership",
    method: "GET",
  });
};

export const getMyMembershipHistory = () => {
  return apiService({
    url: "/v1/my/membership/history",
    method: "GET",
  });
};

export const getMembership = () => {
  return apiService({
    url: "/v1/profiles/membership",
    method: "GET",
  });
};

export const getMembershipPlans = () => {
  return apiService({
    url: "/v1/memberships",
    method: "GET",
    authToken: null,
  });
};

// Delete profile
export const deletingProfile = () => {
  return apiService({
    url: "/v1/profiles",
    method: "DELETE",
  });
};

// Chat
export const startChatConversation = (userId) => {
  return apiService({
    url: `/v1/chats/by-user/${userId}`,
    method: "POST",
  });
};

export const getChatConversations = () => {
  return apiService({
    url: "/v1/chats",
    method: "GET",
  });
};

export const getChatMessages = (conversationId) => {
  return apiService({
    url: `/v1/chats/${conversationId}/messages`,
    method: "GET",
  });
};

//record that the logged-in customer opened the subscription page
export const logSubscriptionPageView = () => {
  return apiService({
    url: "/v1/users/payment-page-viewed",
    method: "POST",
  });
};

//get subscription page visited customer Data
export const getSubscriptionPageVisitedCustomerData = (params = {}) => {
  return apiService({
    url: API.subscriptionLeads,
    method: "GET",
    body: params,
  });
};

//mark a subscription page visitor as contacted
export const deleteViewedContactDetails = (profileId) => {
  return apiService({
    url: API.markSubscriptionLeadNotified(profileId),
    method: "PATCH",
  });
};

//assisted customers waiting for a relationship manager
export const getUnassignedAssistedCustomers = (params = {}) => {
  return apiService({
    url: API.unassignedAssistedCustomers,
    method: "GET",
    body: params,
  });
};

export const getRelationshipManagerWorkload = () => {
  return apiService({
    url: API.relationshipManagerWorkload,
    method: "GET",
  });
};

export const assignRelationshipManager = (profileId, payload) => {
  return apiService({
    url: API.customerRelationshipManager(profileId),
    method: "POST",
    body: payload,
  });
};

export const removeRelationshipManager = (profileId) => {
  return apiService({
    url: API.customerRelationshipManager(profileId),
    method: "DELETE",
  });
};

//profile counts by religion or caste, split by paid and unpaid
export const getCommunityInsights = (params = {}) => {
  return apiService({
    url: API.communityInsights,
    method: "GET",
    body: params,
  });
};

export const createAssosiate = (payload) => {
  return apiService({
    url: `${API.createAssosiate}`,
    method: "POST",
    body: payload,
  });
};

export const createSubordinate = (payload) => {
  return apiService({
    url: `${API.createSubordinate}`,
    method: "POST",
    body: payload,
  });
};

export const profilePageVisited = () => {
  return apiService({
    url: "/v1/profile/payment/page-viewed",
    method: "POST",
  });
};

export const searchByPartnerPreferences = (filterOptions) => {
  return apiService({
    url: "/v1/profiles/search",
    method: "GET",
    body: buildSearchParams(filterOptions),
  });
};
